import { render, staticRenderFns } from "./ServerCritical.vue?vue&type=template&id=18d430e0&"
import script from "./ServerCritical.vue?vue&type=script&lang=js&"
export * from "./ServerCritical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18d430e0')) {
      api.createRecord('18d430e0', component.options)
    } else {
      api.reload('18d430e0', component.options)
    }
    module.hot.accept("./ServerCritical.vue?vue&type=template&id=18d430e0&", function () {
      api.rerender('18d430e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/ServerCritical.vue"
export default component.exports